// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__77jz-","title":"FrontImage_title__1EOCk"};